import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { request } from '../api';
import Layout from '../components/Layout';
import Prompt from '../components/Prompt';
export default function PublicPrompt() {
  const [params] = useSearchParams(),
    [text, setText] = useState(''),
    [error, setError] = useState(''), [locked, setLocked] = useState(false);
  const batch = params.get('batch'),
    horizon = params.get('horizon') || '1d';
  useEffect(() => {
    let live = true;
    request(batch ? `/batches/${batch}/prompt` : `/prompt-template?horizon=${horizon}`).then(d => live && setText(d.prompt)).catch(e => { if (!live) return; if (/administrator|subscribe/i.test(e.message)) setLocked(true); else setError(e.message); });
    return () => {
      live = false;
    };
  }, [batch, horizon]);
  return <Layout title="Standard extreme-movers-ohlc prompt" error={error}>{locked
    ? <div className="text-center p-4"><i className="ri-lock-2-line display-5 text-muted" /><p className="mt-3">The standard prompt is ForecastNest's own research method and is not published, to members or anyone else. Every run keeps its prompt version and SHA-256 fingerprint, which shows the prompt was not changed after the results.</p><a className="btn btn-primary" href="/extreme-movers-ohlc">See the results</a></div>
    : <><p>Copy the standardized prompt into your own AI. A template is illustrative; recording model responses requires a server-issued batch.</p><Prompt text={text} /></>}</Layout>;
}
